import React, { Component } from 'react';
import ReactDataSheet from 'react-datasheet';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import 'react-datasheet/lib/react-datasheet.css';
import './SpreadSheet.css';
import { generateId, showAlertModal } from '../../redux/helpers';
import { createPage } from '../../redux/actions/entities/pages';
import { store } from './../../index';
import { generateWeddingTexts } from '../../redux/helpers/texts';
import { setFirstLayout } from '../../redux/helpers/loadDefaulState';
import { setGeneratedTextToCorrectPosition, setParentBackground } from '../../helpers/weddingHelper';
import { setWeddingTextStatus } from '../../redux/actions/ui/weddingTextGenerated';
import { SavebookLoader } from '../savebook-loader/savebookLoader';

const HeaderText = 'Kattints az alábbi sorra, és illeszd be, vagy gépeld be a neveket!';

class SpreadSheet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      grid: [
        [{
          value: HeaderText,
          readOnly: true,
        }],
        [{
          value: '',
        }],
        [{
          value: '',
        }],
      ],
    };
  }

  handleType = (changes) => {
    const grid = this.state.grid.map(row => [...row]);
    const emptyRow = [{
      value: '',
      row: grid.length,
      col: 0,
      cell: {
        value: '',
      },
    }];

      // Add one new empty row
    const hasEmpty = grid.some(el => el[0].value === '');

    let mergedChanges = [...changes];
    if (hasEmpty) {
      mergedChanges = [...changes, ...emptyRow];
    }
    // Merge new array
    mergedChanges.forEach(({
      row, col, value,
    }) => {
      if (!grid[row]) {
        grid.push(row);
        grid[row] = [col];
      }
      grid[row][col] = {
        ...grid[row][col],
        value,
      };
    });
    this.setState({ grid });
  }

  handleChanges = (changes, data) => {
    if (data) {
      const mergedData = [...this.state.grid[0], ...changes, ...data];
      const newGrid = mergedData.map(element => ([{
        value: element.value,
        readOnly: element.readOnly || false,
      }]));
      this.setState({ grid: newGrid });
    } else {
      this.handleType(changes);
    }
  }

  generateSpreadSheetTexts = async () => {
    const { grid } = this.state;
    const { updatePlacecardSubmit, dispatch, lang } = this.props;

    const removeEmptyCells = grid.filter(element => element[0].value !== '').filter(el => el[0].value !== HeaderText);
    if (removeEmptyCells.length === 0) {
      return showAlertModal(lang.title_notice, lang.OneNameRequired);
    }

    dispatch(setWeddingTextStatus(true));
    for (const [index, el] of removeEmptyCells.entries()) {
      const page = {
        layout: 0,
        placeholders: [],
        order: 0,
        isActive: true,
      };

      const text = {
        text: el[0].value,
        fontSize: 80,
        type: 'Creative',
      };

      const pageId = generateId(store.getState().entities.pages.allIds);
      dispatch(createPage(Object.assign({}, page, { order: index })));
      await generateWeddingTexts(store, text, pageId);

      const firstPage = index === 0;
      const newPageId = store.getState().entities.pages.allIds;
      setFirstLayout(store, 10, newPageId[index], firstPage);
    }

    setGeneratedTextToCorrectPosition(store);
    updatePlacecardSubmit();
    dispatch(setWeddingTextStatus(false));
    const getParentStyles = this.props.parentStyle;
    await setParentBackground({ success: getParentStyles }, store);
  }

  render() {
    const { setWeddingTextStatus, lang } = this.props;
    if (setWeddingTextStatus) {
      return <SavebookLoader lang={lang} />;
    }


    return (
      <div id="SpreadSheetWrapper">
        <div>
          <p className="intro" dangerouslySetInnerHTML={{ __html: lang.spreadSheetIntro }} />
          <ReactDataSheet
            data={this.state.grid}
            valueRenderer={cell => cell.value}
            onCellsChanged={this.handleChanges}

          />
          <button onClick={() => this.generateSpreadSheetTexts()} className="generateButton">
            {lang.generate}
          </button>
        </div>
      </div>
    );
  }
}

SpreadSheet.defaultProps = {
  updatePlacecardSubmit: () => {},
  setWeddingTextStatus: false,
  lang: {},
  parentStyle: {},
};

SpreadSheet.propTypes = {
  updatePlacecardSubmit: PropTypes.func,
  setWeddingTextStatus: PropTypes.bool,
  lang: PropTypes.object,
  parentStyle: PropTypes.object,
};

export default connect(state => ({
  weddingTextStatus: state.editorUI.setWeddingTextStatus,
  parentStyle: state.bookProperties.parentStyle,
}))(SpreadSheet);




// WEBPACK FOOTER //
// ./src/components/spreadsheet/SpreadSheet.jsx